import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HttpClientModule } from '@angular/common/http';
import { TranslateService } from './Services/translate.service';
import { TranslatePipe } from './pipes/translate.pipe';
import { HomeLayoutComponent } from './layout/home-layout/home-layout.component';
import { PagesLayoutComponent } from './layout/pages-layout/pages-layout.component';
import { DropdownComponent } from './component/dropdown/dropdown.component';
import { SliderComponent } from './component/slider/slider.component';
import { HomeComponent } from './modules/home/home.component';
import { ArchiveComponent } from './modules/archive/archive.component';
import { PagesComponent } from './modules/pages/pages.component';
import { SliderDetayComponent } from './modules/slider-detay/slider-detay.component';
import { ToTextCamelCasePipe } from './pipes/toTextCamelCase.pipe';



export function setupTranslateFactory(
  service: TranslateService): Function {
  return () => service.use('tr');
}

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    SliderComponent,
    TranslatePipe,
    PagesComponent,
    DropdownComponent,
    ArchiveComponent,
    PagesLayoutComponent,
    HomeLayoutComponent,
    SliderDetayComponent,
    ToTextCamelCasePipe
    
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgbModule,
    HttpClientModule,

  
    
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: setupTranslateFactory,
      deps: [ TranslateService ],
      multi: true
    }

  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
